import { KeyboardKeys } from 'constants/';

export const getNormalizedKeyboardKey = (event: KeyboardEvent): KeyboardKeys => {
  if (event?.key == null || event.key === '') {
    return '' as KeyboardKeys;
  }
  const normalizedKey = event.key.length === 1 ? event.key.toLowerCase() : event.key;
  return normalizedKey as KeyboardKeys;
};
